/*
 * -----------------------------------------------------------------------
 *  <copyright file="i18n.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import adminEN_US from './translations/en-us/admin.json';
import auditLogEN_US from './translations/en-us/audit-log.json';
import centralMonitoringEN_US from './translations/en-us/central-monitoring.json';
import commentsEN_US from './translations/en-us/comments.json';
import commonEN_US from './translations/en-us/common.json';
import dataQualityEN_US from './translations/en-us/data-quality.json';
import eventLogEN_US from './translations/en-us/event-log.json';
import homeEN_US from './translations/en-us/home.json';
import legacyRiskAssessmentEN_US from './translations/en-us/legacy-risk-assessment.json';
import loginEN_US from './translations/en-us/login.json';
import protocolInsightsEN_US from './translations/en-us/protocol-insights.json';
import reportsEN_US from './translations/en-us/reports.json';
import riskAssessmentEN_US from './translations/en-us/risk-assessment.json';
import seedDataEN_US from './translations/en-us/seed-data.json';
import siteEN_US from './translations/en-us/site.json';
import studyEN_US from './translations/en-us/study.json';
import subjectMonitoringEN_US from './translations/en-us/subject-monitoring.json';
import subjectEN_US from './translations/en-us/subject.json';
import systemLogEN_US from './translations/en-us/system-log.json';
import uamEN_US from './translations/en-us/uam.json';

import commonFR from './translations/fr/common.json';
import loginFR from './translations/fr/login.json';

import commonZhCn from './translations/zh-cn/common.json';
import legacyRiskAssessmentZhCn from './translations/zh-cn/legacy-risk-assessment.json';
import loginZhCn from './translations/zh-cn/login.json';

import commonZhTw from './translations/zh-tw/common.json';
import loginZhTw from './translations/zh-tw/login.json';

declare module 'i18next' {
    interface CustomTypeOptions {
        returnNull: false;
    }
}

const resources = {
    'en-US': {
        common: commonEN_US,
        login: loginEN_US,
        auditLog: auditLogEN_US,
        eventLog: eventLogEN_US,
        seed: seedDataEN_US,
        systemLog: systemLogEN_US,
        cm: centralMonitoringEN_US,
        sm: subjectMonitoringEN_US,
        ra: legacyRiskAssessmentEN_US,
        ram: riskAssessmentEN_US,
        protocolInsights: protocolInsightsEN_US,
        site: siteEN_US,
        home: homeEN_US,
        study: studyEN_US,
        subject: subjectEN_US,
        reports: reportsEN_US,
        admin: adminEN_US,
        uam: uamEN_US,
        dataQuality: dataQualityEN_US,
        comments: commentsEN_US,
    },
    fr: {
        common: commonFR,
        login: loginFR,
    },
    'zh-CN': {
        common: commonZhCn,
        login: loginZhCn,
        ra: legacyRiskAssessmentZhCn,
    },
    'zh-TW': {
        common: commonZhTw,
        login: loginZhTw,
    },
};

const LANGUAGE = 'en-US';

export default {
    init: () => {
        i18n
            // learn more: https://github.com/i18next/i18next-browser-languageDetector
            // .use(LanguageDetector)
            // pass the i18n instance to react-i18next.
            .use(initReactI18next)
            // init i18next
            // for all options read: https://www.i18next.com/overview/configuration-options
            .init({
                resources,
                lng: navigator && navigator.languages ? navigator.languages[0] : LANGUAGE,
                fallbackLng: LANGUAGE,
                debug: false,
                returnNull: false,
                defaultNS: 'common',
                parseMissingKeyHandler(key: string, defaultValue: string | undefined) {
                    return defaultValue || key;
                },
                saveMissing: true,
                missingKeyHandler: (lng: readonly string[], ns: string, key: string, fallbackValue: string) => {
                    console.warn(`Missing translation: ${lng} ${ns}:${key}`);
                },
            });
    },
    setLanguage: (language: string) => i18n.changeLanguage(language),
};
